import { useEffect, useState } from 'react';
import { listAccessibleBoards } from '../../../utils/boardApi';

export default function useHasAccessibleBoardArchive(teamId, enabled = true) {
  const [hasBoardArchive, setHasBoardArchive] = useState(false);

  useEffect(() => {
    if (!enabled || !teamId) {
      setHasBoardArchive(false);
      return undefined;
    }

    let cancelled = false;
    setHasBoardArchive(false);
    listAccessibleBoards({ teamId })
      .then((result) => {
        if (cancelled) return;
        setHasBoardArchive(Array.isArray(result?.boards) && result.boards.length > 0);
      })
      .catch(() => {
        if (!cancelled) setHasBoardArchive(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, teamId]);

  return hasBoardArchive;
}
